import React , { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Award, Users, Shield, Target, ArrowRight, CheckCircle, TrendingUp, Heart } from 'lucide-react';

const LendingPartners = () => {
  useEffect(() => {
    document.title = "Our Lending Partners | PFIL Finance";
  }, []);

  const values = [
    {
      icon: <Shield className="h-8 w-8" />,
      title: "Trust & Transparency",
      description: "We believe in complete transparency in all our dealings and maintain the highest standards of integrity."
    },
    {
      icon: <Users className="h-8 w-8" />,
      title: "Customer First",
      description: "Our customers are at the heart of everything we do. We strive to exceed their expectations."
    },
    {
      icon: <Target className="h-8 w-8" />,
      title: "Excellence",
      description: "We are committed to delivering exceptional service and innovative financial solutions."
    },
    {
      icon: <Heart className="h-8 w-8" />,
      title: "Innovation Driven",
      description: "Digital-first approach with modern financial tools to serve you better."
    }
  ];

  const achievements = [
    { number: '29+', label: 'Years of Experience' },
    { number: '10,000+', label: 'Happy Customers' },
    { number: 'Substantial', label: 'Loans Disbursed' },
    { number: '99.5%', label: 'Customer Satisfaction' }
  ];

  const whyChoose = [
    {
      title: "Established in 1996",
      description: "Over 29 years of financial excellence and trust in the industry."
    },
    {
      title: "RBI Registered NBFC",
      description: "Fully compliant with national financial regulations and guidelines."
    },
    {
      title: "Customer First Approach",
      description: "Personalized, fast, and reliable service tailored to your needs."
    },
    {
      title: "Innovation Driven",
      description: "Digital-first approach with modern financial tools and secure platforms."
    }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-50 to-indigo-100 py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <div className="space-y-8">
            <div className="flex justify-center mb-8">
              <img 
                src="https://customer-assets.emergentagent.com/job_persian-indigo-fin/artifacts/d9xink6u_2897_Logo_V-PNG-01.png" 
                alt="PFIL Finance Logo" 
                className="h-32 w-auto"
              />
            </div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              Our <span style={{ color: '#340C7F' }}>Lending Partners</span>
            </h1>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
             Our strategic partnerships ensure a seamless, transparent application process built on a foundation of trust and reliability.
            </p>
            
          </div>
        </div>
      </section>

     

      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="relative">
              <img 
                src="https://pfilfinance.com/images/megma_loans.jpeg" 
                alt="Our Lending Partners" 
                className="rounded-2xl shadow-2xl"
                
              />
            </div>

            <div className="space-y-8">
              <div className="space-y-4">
                <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">
                  <span style={{ color: '#340C7F' }}>Megma Loans</span>
                </h2>
                <p className="text-lg text-gray-600 leading-relaxed">
                  Megma Loans, a lending service provider is a fully digital personal loan app developed and operated by GSL FINANCIAL SERVICES, in partnership with Pooja Finstock International Limited (PFIL) (an RBI-registered NBFC).
                </p>
              </div>

              <div className="space-y-4">
                {[
                  '100% Digital Onboarding via Mobile App',
                  'Real-Time Credit Score Evaluation',
                  'Aadhaar & PAN Based eKYC Verification',
                  'Secure & RBI-Compliant Lending'
                ].map((item, index) => (
                  <div key={index} className="flex items-center space-x-3">
                    <CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0" />
                    <span className="text-gray-700">{item}</span>
                  </div>
                ))}


                <br/>

                <div className="space-y-6">
                  <div className="flex flex-col space-y-2">
                    <span className="text-gray-500 text-sm">Application Name</span>
                    <span className="text-xl font-bold text-gray-900">Megma Loans</span>
                  </div>
                  <div className="h-px bg-gray-200 w-full"></div>
                  <div className="flex flex-col space-y-2">
                    <span className="text-gray-500 text-sm">Developer Name</span>
                    <span className="text-xl font-bold text-gray-900">GSL FINANCIAL SERVICES</span>
                  </div>
              </div>

              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default LendingPartners;